// extracted by mini-css-extract-plugin
module.exports = {"select":"degreeSelect_select__3HHv7"};